import { bootstrapApplication } from '@angular/platform-browser';
import { config } from 'devextreme/common';
import App from './app/app';
import { appConfig } from './app/app.config';
import { licenseKey } from './devextreme-license';

config({ licenseKey });

try {
  await bootstrapApplication(App, appConfig);
} catch (err) {
  console.error(err);
}
